<script>
    import { slide } from 'svelte/transition';
    import {flip} from 'svelte/animate';

    export let filter_items;
    export let title;
    // export let change_function;

    export let show_menu = false;
    let hovering = false;

    const drop = (event, target) => {
    event.dataTransfer.dropEffect = 'move'; 
    const old_index = parseInt(event.dataTransfer.getData("text/plain"));
    const new_index = target;

    const new_filter_items = filter_items;

    // const newTracklist = list

    // if (start < target) {
    if (old_index < new_index) {
        new_filter_items.splice(new_index + 1, 0, new_filter_items[old_index]);
        new_filter_items.splice(old_index, 1);
    //   newTracklist.splice(target + 1, 0, newTracklist[start]);
    //   newTracklist.splice(start, 1);
    } else {
        new_filter_items.splice(new_index, 0, new_filter_items[old_index]);
        new_filter_items.splice(old_index + 1, 1);
    //   newTracklist.splice(target, 0, newTracklist[start]);
    //   newTracklist.splice(start + 1, 1);
    }
    // list = newTracklist
    filter_items = new_filter_items;
    hovering = null
    // change_function(new_filter_items);
  }

  const dragstart = (event, i) => {
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.dropEffect = 'move';
    const start = i;
    event.dataTransfer.setData('text/plain', start);
  }

  const doDragEnter = (i) => {
      hovering = i;
  }
</script>

<div class="filterbuttonholder">
    <div class="titlebutton"><button on:click={() => {show_menu = !show_menu}} style="margin-top: 0px; margin-bottom: 0px;"><i class="fas fa-tasks"></i> {title}</button></div>
    {#if show_menu}
        {#each filter_items as ni, index  (ni.t)}
        <div 
        on:dragstart={event => dragstart(event, index)} 
        on:drop|preventDefault={event => drop(event, index)} 
        ondragover="return false" 
        on:dragenter={() => {doDragEnter(index);}}  
        animate:flip 
        draggable={true} 
        transition:slide 
        class="optionbutton buttonholder">
        <button class:is-active={hovering === index} on:click={() => {filter_items[index]['a'] = !(filter_items[index]['a'])}} style="margin-top: 0px; margin-bottom: 0px;"><i class="fas fa-grip-vertical grayed"></i> <i class="far fa-{(ni.a) ? "check-square" : "square" }"></i>  {ni.t}</button>
    </div>        
        {/each}
    {/if}
</div>

<style>
    .grayed {
        color: #aaa !important;
    }
    .is-active {
        background-color: #3273dc;
        color: #fff;
    }
        
    .filterbuttonholder {
        /* max-width: 200px; */
        width: 200px;
        display: flex;
        flex-direction: column;
        padding: 0px;
        gap: 0px;
    }
    .buttonholder {
        padding: 0px;
        margin: 0px;
        text-align: left !important;
    }
    .filterbuttonholder button {
        /* width: 200px; */
        width: 100%;
        text-align: left !important;
    }
    .titlebutton {
        text-align: center !important;
    }
    .titlebutton button{
        background-color: #1769aa;
        color: white;
        /* font-weight: bold; */
        /* padding: 5px; */
        width: 100%;
        text-align: center !important;
        border: none;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .filterbuttonholder {
            max-width: 100%;
            width: 100%;
        }
        .filterbuttonholder button {
            width: 100%;
            margin: 0px;
            text-align: left;
        }
    }
</style>